var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashbordHamMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2383 13.0012C11.2383 14.1375 12.1603 15.059 13.2961 15.059C14.0941 15.059 14.778 14.6003 15.1194 13.9367L15.1251 13.9419L18.8817 7.16447L12.2869 11.2085L12.2931 11.2147C11.6669 11.5681 11.2383 12.2312 11.2383 13.0012ZM21.5865 3.19568C19.4778 1.35268 16.7533 0.175895 13.6401 0V3.12719C16.2344 3.29219 17.763 4.11615 19.2978 5.40189L21.5865 3.19568ZM23.0554 12.0262H26.179C25.9693 8.91304 24.7516 6.35504 22.8608 4.25883L20.651 6.45518C21.9824 7.98064 22.8582 9.95077 23.0554 12.0262Z",
    fill: "#8DC63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0702 13.5833C22.7397 18.7719 18.4409 22.887 13.19 22.887C7.72381 22.887 3.11318 18.4538 3.11318 12.9881C3.11318 7.78497 7.41404 3.52769 12.0838 3.12817V0.000976562C5.33859 0.405171 0 6.0805 0 13.0016C0 20.1843 5.92542 26.0002 13.1081 26.0002C20.0774 26.0002 25.8669 20.3285 26.1995 13.5833H23.0702Z",
    fill: "#8DC63F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbordHamMenu);
export default __webpack_public_path__ + "static/media/dashbord_ham_menu.dfc4f7dba7d0b1664b00bada44c8250e.svg";
export { ForwardRef as ReactComponent };